import React from "react";
import styles from "./Breadcrumbs.module.scss";
import { Flex } from "@mantine/core";
import { Link } from "react-router-dom";

interface IBreadcrumbContainer {
  border?: boolean;
  pb?: number;
}

export const BreadcrumbContainer: React.FC<
  IBreadcrumbContainer & React.HTMLAttributes<HTMLDivElement>
> = ({ border, pb, children, className, style, ...rest }) => (
  <Flex
    className={`${styles.breadcrumbContainer} ${border ? styles.withBorder : ""} ${className ?? ""}`}
    style={{ ...(style || {}), ...(pb ? { paddingBottom: `${pb}px` } : {}) }}
    {...(rest as any)}>
    {children}
  </Flex>
);

export const BreadcrumbLink: React.FC<React.ComponentProps<typeof Link>> = ({
  children,
  className,
  ...rest
}) => (
  <Link className={`${styles.breadcrumbLink} ${className ?? ""}`} {...rest}>
    {children}
  </Link>
);
